export const bigcommerce = {
  tokenHelp: 'The token can be found under "Settings > Store-level API account"'
};
